import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Collapsible, Dropdown, StateConfigContext, getTestId, isValidObject } from '@airtel/air-design-system';
import { debounce, merge } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Keyboard, View } from 'react-native';
import { LinkListItemWidget } from '../../../link-list-item-widget';
import { getSkycFormWidgetStyles } from '../../SkycFormWidgetStyles';
import { getIsDisabledState, getSubHeading } from './IncomeDetailsVerificationUtils';
import { getIncomeDetailsVerificationSytles } from './IncomeDetailsVerificationStyles';
import { incomeDetailsVerificationConfig, successAvatarConfig } from './IncomeDetailsVerificationConfig';
export var IncomeDetailsVerification = props => {
  var _a, _b;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useMemo = useMemo(() => merge({}, incomeDetailsVerificationConfig, props), [incomeDetailsVerificationConfig, props]),
    variant = _useMemo.variant,
    _state = _useMemo.state,
    successStateHeading = _useMemo.successStateHeading,
    isExpanded = _useMemo.isExpanded,
    disableToggle = _useMemo.disableToggle,
    testID = _useMemo.testID,
    autoFormSubmitDebounceDelay = _useMemo.autoFormSubmitDebounceDelay,
    isAutoFormSubmitDebounceAllowed = _useMemo.isAutoFormSubmitDebounceAllowed,
    style = _useMemo.style,
    onUserAction = _useMemo.onUserAction,
    id = _useMemo.id,
    _stepDetails = _useMemo.stepDetailsProps,
    onStepDetailsListItemPressMetaData = _useMemo.onStepDetailsListItemPressMetaData,
    onStepDetailsCtaPressMetaData = _useMemo.onStepDetailsCtaPressMetaData,
    _checkboxProps = _useMemo.checkboxProps,
    onCheckboxActionCtaPressMetaData = _useMemo.onCheckboxActionCtaPressMetaData,
    onValidFormMetaData = _useMemo.onValidFormMetaData,
    dropdownsDataProps = _useMemo.dropdownsDataProps;
  var incomeDropdown = dropdownsDataProps.incomeDropdown,
    familyIncomeDropdown = dropdownsDataProps.familyIncomeDropdown;
  var _useState = useState((incomeDropdown === null || incomeDropdown === void 0 ? void 0 : incomeDropdown.value) || ''),
    incomeDropdownValue = _useState[0],
    setIncomeDropdownValue = _useState[1];
  var _useState2 = useState((familyIncomeDropdown === null || familyIncomeDropdown === void 0 ? void 0 : familyIncomeDropdown.value) || ''),
    familyIncomeDropdownValue = _useState2[0],
    setFamilyIncomeDropdownValue = _useState2[1];
  var _useState3 = useState((_a = _checkboxProps === null || _checkboxProps === void 0 ? void 0 : _checkboxProps.checked) !== null && _a !== void 0 ? _a : false),
    checked = _useState3[0],
    setChecked = _useState3[1];
  var _useState4 = useState(isExpanded),
    isExpandedState = _useState4[0],
    setIsExpandedState = _useState4[1];
  var _useState5 = useState(_state),
    stateType = _useState5[0],
    setStateType = _useState5[1];
  var _useState6 = useState((_b = _stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading) !== null && _b !== void 0 ? _b : ''),
    subHeading = _useState6[0],
    setSubHeading = _useState6[1];
  var isDisabledState = stateType === 'disabled';
  var isSuccessState = stateType === 'success';
  var skycFormWidgetStyle = getSkycFormWidgetStyles(props);
  var incomeDetailVerificationStyle = getIncomeDetailsVerificationSytles();
  useEffect(() => {
    setSubHeading(_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading);
  }, [_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeading]);
  useEffect(() => {
    setStateType(_state);
    setIsExpandedState(_state === 'none');
  }, [_state]);
  useEffect(() => {
    setChecked(_checkboxProps === null || _checkboxProps === void 0 ? void 0 : _checkboxProps.checked);
  }, [_checkboxProps === null || _checkboxProps === void 0 ? void 0 : _checkboxProps.checked]);
  useEffect(() => {
    setIsExpandedState(isExpanded);
    if (!isExpanded) Keyboard.dismiss();
  }, [isExpanded]);
  var useDebouncedFunction = callback => {
    return useCallback(debounce(callback, autoFormSubmitDebounceDelay), [autoFormSubmitDebounceDelay]);
  };
  var functionDebounce = useDebouncedFunction((metaData, formData, formData2) => {
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, metaData), {
      props,
      formData,
      formData2,
      checked
    });
  });
  var handleValidation = (formData, formData2, isChecked) => {
    var isValid = (formData === null || formData === void 0 ? void 0 : formData.length) && (formData2 === null || formData2 === void 0 ? void 0 : formData2.length) && isChecked;
    var handleUserAction = metaData => {
      if (isValidObject(metaData)) {
        if (isAutoFormSubmitDebounceAllowed) {
          functionDebounce(metaData, formData, formData2);
        } else {
          onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, metaData), {
            props,
            formData,
            formData2
          });
        }
      }
    };
    if (isValid) handleUserAction(onValidFormMetaData);
    return;
  };
  var handleDropdownChange = (data, dropdownType) => {
    var _a, _b, _c;
    var value = (_a = data[2]) === null || _a === void 0 ? void 0 : _a.subHeading;
    setStateType('none');
    setSubHeading('');
    var updatedIncomeProps, updatedFamilyIncomeProps;
    if (dropdownType === 'income') {
      updatedIncomeProps = {
        incomeDropdownValue: value,
        state: 'none'
      };
      setIncomeDropdownValue(value);
      if (incomeDropdown === null || incomeDropdown === void 0 ? void 0 : incomeDropdown.onChangeMetaData) {
        onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, incomeDropdown === null || incomeDropdown === void 0 ? void 0 : incomeDropdown.onChangeMetaData), Object.assign({}, updatedIncomeProps));
      }
    } else if (dropdownType === 'familyIncome') {
      updatedFamilyIncomeProps = {
        familyIncomeDropdownValue: value,
        state: 'none'
      };
      setFamilyIncomeDropdownValue(value);
      if (familyIncomeDropdown === null || familyIncomeDropdown === void 0 ? void 0 : familyIncomeDropdown.onChangeMetaData) {
        onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, familyIncomeDropdown === null || familyIncomeDropdown === void 0 ? void 0 : familyIncomeDropdown.onChangeMetaData), Object.assign({}, updatedFamilyIncomeProps));
      }
    }
    handleValidation((_b = updatedIncomeProps === null || updatedIncomeProps === void 0 ? void 0 : updatedIncomeProps.incomeDropdownValue) !== null && _b !== void 0 ? _b : incomeDropdownValue, (_c = updatedFamilyIncomeProps === null || updatedFamilyIncomeProps === void 0 ? void 0 : updatedFamilyIncomeProps.familyIncomeDropdownValue) !== null && _c !== void 0 ? _c : familyIncomeDropdownValue, checked);
  };
  var onCheckboxPress = data => {
    setChecked(prevState => {
      handleValidation(incomeDropdownValue, familyIncomeDropdownValue, !prevState);
      if (_checkboxProps === null || _checkboxProps === void 0 ? void 0 : _checkboxProps.onChangeMetaData) {
        onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, _checkboxProps === null || _checkboxProps === void 0 ? void 0 : _checkboxProps.onChangeMetaData), Object.assign(Object.assign(Object.assign({}, data), {
          checked: !prevState
        }), props));
      }
      return !prevState;
    });
  };
  var handleChangeButtonPress = () => {
    setIsExpandedState(true);
  };
  return isValidObject(_stepDetails) && _jsx(Collapsible, Object.assign({}, getTestId(testID, variant + "_Collapsible"), {
    theme: theme,
    withCard: true,
    style: [skycFormWidgetStyle.heading, style],
    titleNoVerticalPadding: true,
    titleNoHorizontalPadding: true,
    childPaddingToken: "SPACING_0",
    titlePaddingToken: "SPACING_0",
    showIcon: false,
    isExpanded: isExpandedState,
    disabled: getIsDisabledState(isDisabledState, disableToggle),
    removeOverflow: true,
    titleComponent: _jsx(LinkListItemWidget, Object.assign({}, _stepDetails, isSuccessState && !isExpandedState && successStateHeading && {
      heading: successStateHeading
    }, getTestId(testID, variant + "_StepDetails"), {
      roundedCorners: true,
      theme: theme,
      noHoverEffect: true,
      noPressEffect: true,
      onPress: onStepDetailsListItemPressMetaData,
      onUserAction: onUserAction,
      actionTypeProps: !isExpandedState && !isDisabledState && (_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.actionTypeProps),
      actionTypeOnPressMetaData: onStepDetailsCtaPressMetaData,
      actionTypeOnPress: handleChangeButtonPress
    }, isSuccessState && Object.assign({}, successAvatarConfig), isSuccessState && !isExpandedState && {
      subHeading: getSubHeading(incomeDropdownValue, familyIncomeDropdownValue, subHeading)
    }, {
      subHeadingNumberOfLines: (_stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.subHeadingNumberOfLines) || 1,
      disabled: getIsDisabledState(isDisabledState, _stepDetails === null || _stepDetails === void 0 ? void 0 : _stepDetails.disabled)
    }))
  }, {
    children: _jsxs(View, Object.assign({
      style: [skycFormWidgetStyle.content]
    }, {
      children: [_jsx(Dropdown, Object.assign({}, incomeDropdown, getTestId(testID, variant + "_IncomeDropdown"), {
        theme: theme,
        position: "below",
        listMaxHeightPercentage: 30,
        onSelectedHandler: function onSelectedHandler() {
          for (var _len = arguments.length, value = new Array(_len), _key = 0; _key < _len; _key++) {
            value[_key] = arguments[_key];
          }
          return handleDropdownChange(value, 'income');
        }
      })), _jsx(View, Object.assign({
        style: [incomeDetailVerificationStyle.familyIncome]
      }, {
        children: _jsx(Dropdown, Object.assign({}, familyIncomeDropdown, getTestId(testID, variant + "_FamilyIncomeDropdown"), {
          theme: theme,
          position: "below",
          listMaxHeightPercentage: 30,
          onSelectedHandler: function onSelectedHandler() {
            for (var _len2 = arguments.length, value = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              value[_key2] = arguments[_key2];
            }
            return handleDropdownChange(value, 'familyIncome');
          }
        }))
      })), _jsx(Checkbox, Object.assign({}, _checkboxProps, getTestId(testID, variant + "_Checkbox"), {
        theme: theme,
        checked: checked,
        onPress: data => onCheckboxPress(data),
        onActionCtaPress: () => {
          onCheckboxActionCtaPressMetaData && onUserAction(Object.assign({
            id
          }, onCheckboxActionCtaPressMetaData), _checkboxProps);
        },
        disabled: getIsDisabledState(isDisabledState, _checkboxProps === null || _checkboxProps === void 0 ? void 0 : _checkboxProps.disabled),
        style: [skycFormWidgetStyle.checkBoxWidget]
      }))]
    }))
  }));
};